import { AccordionTextModule } from "../Accordions/accordion-text";

export class VideoModalModule {

    constructor() {
        this.init();

    }

    init() {

        if ($(".modal-video__link")) {
            var videoSrc;

            $(".modal-video__link").on("click", function () {
                videoSrc = $(this).data("src");
                $("#video-youtube").attr('src', videoSrc);

            });

            $('#modal-video').on('shown.bs.modal', function () {

            });

            $('body').on('hidden.bs.modal', '.modal', function () {
                $(this).removeData('bs.modal');
                $("#video-youtube").attr('src', videoSrc);
            });
        }

        // $("body").on("click", ".feature-grid__item--image a", function (e) {

        // var button = $(this);           
        $(".button.button--green-rounded.button--centered").on("click", function (e) {
            e.preventDefault();
            var dataURL = $(this).data('src');
            if (dataURL != '' && dataURL != 'undefined') {
                var url = 'CustomApi/PageContent?url=' + dataURL;
                $.ajax({
                    type: "GET",
                    url: apilocation + url,
                    dataType: "json",
                    async: false,
                    cache: false,
                    success: function (response) {
                        $('.modal-title').html(response.con.header);
                        $('.modal-header h6').html(response.con.copy);
                        $('.modal-body p').html(response.con.Description);
                        var accordionContent = "";
                         var i = 1;
                        $.each(response.con.AccordionItems, function (key, val) {
                           
                           
                            var html = '<div class="card u-shadow"><div class="card-body" style="margin-bottom:10px;">'
                            html += '<div class="card-title" id="' + val.header+ '">'
                            html += '<h4 class="mb-0">'
                            html += '<button class="btn btn-link btn-lg text-brand" style="Width:100%;text-align:left;" data-toggle="collapse" data-target="#content-'+i+'"" aria-expanded="false">' + val.header
                            html += '<i class="fa fa-plus float-right"></i></button></h4></div>'
                           // html += '<svg class="svg-inline--fa fa-plus fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="plus"></svg>'
                            html += '<div id="content-'+i+ '"" class="collapse" aria-labelledby="' + val.header +'" style="">'
                            html += '<div class="card-text" style="padding: 0px 20px 10px 20px;">'
                            html += '<p>' + val.Description + '</p>'
                            html += '</div></div></div></div>';
                            accordionContent += html;
                           
                            i = i + 1;
                        });
                        $(".accordion").html(accordionContent);
                    }

                });
            }
            $(".collapse.show").each(function () {
                $(this).prev(".card-title").find("i").addClass("fa-minus").removeClass("fa-plus");
            });

            // Toggle plus minus icon on show hide of collapse element
            $(".collapse").on('show.bs.collapse', function () {
                $(this).prev(".card-title").find("i").removeClass("fa-plus").addClass("fa-minus");
            }).on('hide.bs.collapse', function () {
                $(this).prev(".card-title").find("i").removeClass("fa-minus").addClass("fa-plus");
            });
        });


       
         
        

    }
}





